<script setup>
import UpdateXeroSettings from '@/Components/Xero/UpdateXeroSettings.vue'

import { Inertia } from '@inertiajs/inertia'
import { ref } from 'vue'
import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

const props = defineProps({
	xeroSettings: {
		type: Object, // this will actually be an InertiaForm object
		required: true,
	},
})

const saveBtn = ref(null) // template ref

function updateXeroSettings() {
	saveBtn.value.waitFor(
		props.xeroSettings.put('/xero-settings/1')
	)
}
</script>

<template>
	<SectionCard 
		title="Update Xero settings"
		v-if="auth.isAdmin"
	>
		<UpdateXeroSettings 
			:settings="xeroSettings" 
			@update:xero-settings="updateXeroSettings"
		/>
		<template #footer>
			<PromiseButton
				ref="saveBtn"
				type="button"
				color="blue"
				class="mt-4"
				@click="updateXeroSettings"
				data-testid="update-xero-settings-btn"
			> Save Xero Settings
			</PromiseButton>
		</template>
	</SectionCard>
</template>